import React, { useState, useEffect } from "react";
import axios from "axios";

import { useNavigate, useLocation } from "react-router-dom";

const RazorpayCheckout = () => {
  const [loading, setLoading] = useState(false);
  const [statusMsg, setStatusMsg] = useState("");
  const [email, setEmail] = useState(localStorage.getItem("userName") || "");
  const [emailError, setEmailError] = useState("");

  const navigate = useNavigate();

  // Set subscription dates
  const today = new Date(); // July 11, 2025, 8:17 PM IST
  const sixMonthsLater = new Date(today);
  sixMonthsLater.setMonth(today.getMonth() + 6); // January 11, 2026
  const subscriptionStartDate = today.toISOString();
  const subscriptionEndDate = sixMonthsLater.toISOString();

  // Store dates in localStorage
  useEffect(() => {
    localStorage.setItem("subscriptionStartDate", subscriptionStartDate);
    localStorage.setItem("subscriptionEndDate", subscriptionEndDate);
  }, []);

  const product = {
    name: "Invoice Plus Subscription",
    price: 399, // ₹499
  };

  const loadRazorpayScript = () =>
    new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = () => resolve(true);
      script.onerror = () => resolve(false);
      document.body.appendChild(script);
    });

 const pollPaymentStatus = (orderId,retryTime) => {
    let retries = 0;
    const maxRetries = 10;

    const interval = setInterval(async () => {
      try {
        const userId = localStorage.getItem("userName");
        const { data } = await axios.get(`https://www.dhandhakarle.com/api/status/${userId}/${orderId}`);
        if (data.status === "PAID") {
          clearInterval(interval);
          //alert("Payment confirmed! Thank you.");
          localStorage.setItem('userName','');
          setEmail("");
          //window.location.reload();
          navigate("/");
          alert("Payment confirmed! Thank you.");
          setStatusMsg("");
        }
        else if (data.status === "FAILED") {
          clearInterval(interval);
          alert("Payment failed. Please try again.");
          setStatusMsg("");
        } else if (++retries >= maxRetries) {
          clearInterval(interval);
          alert("Payment not confirmed yet. Please contact support.");
          window.location.reload();
          setStatusMsg("");
        }
        else{
            alert("checking status");
        }
      } catch (err) {
        console.error("Polling error:", err);
      }
    }, retryTime); // 30s
  };

  const handlePayment = async () => {
    debugger;
    setLoading(true);
    setStatusMsg("");

    const res = await loadRazorpayScript();
    if (!res) {
      alert("Razorpay SDK failed to load.");
      setLoading(false);
      return;
    }

    try {
      const userId = localStorage.getItem("userName");
      if (!userId) {
        alert("Please enter a valid email address.");
        setLoading(false);
        return;
      }

      const { data: order } = await axios.post("https://www.dhandhakarle.com/api/create-order", {
        userId,
      });

      const options = {
       key: "rzp_live_bnDXAzoSyCp3ac",
        amount: order.amount,
        currency: order.currency,
        name: "Your Brand",
        description: product.name,
        order_id: order.id,
        handler: function (response) {
          setStatusMsg("Processing payment... Please wait up to 5 minutes.Do not reload this window.");
         // pollPaymentStatus(order.id);
          },
          modal: {
              ondismiss: function () {
                  // Razorpay checkout popup closed — start polling now
                  console.log('Razorpay window closed');

                  pollPaymentStatus(order.id,60000);
              }
          },
          prefill: {
          name: "John Doe",
          email: userId, // Use entered email
          contact: "9999999999",
        },
        theme: { color: "#3399cc" },
      };

      new window.Razorpay(options).open();
      pollPaymentStatus(order.id,30000);
    } catch (error) {
      alert("Failed to initiate payment: " + (error.response?.data?.error || error.message));
    } finally {
      setLoading(false);
    }
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    if (!validateEmail(newEmail)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
      localStorage.setItem("userName", newEmail);
    }
  };

  const isSubscriptionValid = (subscriptionEndDate) => {
    if (!subscriptionEndDate || isNaN(new Date(subscriptionEndDate))) return false;
    const endDate = new Date(subscriptionEndDate);
    const currentDate = new Date();
    const endDateMidnight = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    const currentDateMidnight = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    return endDateMidnight >= currentDateMidnight;
  };

  const isWithin15Days = (subscriptionEndDate) => {
    if (!subscriptionEndDate || isNaN(new Date(subscriptionEndDate))) return false;
    const endDate = new Date(subscriptionEndDate);
    const currentDate = new Date();
    const endDateMidnight = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
    const currentDateMidnight = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const diffDays = (endDateMidnight - currentDateMidnight) / (1000 * 60 * 60 * 24);
    return diffDays >= 0 && diffDays <= 15;
  };

  const shouldShowPopup = !isSubscriptionValid(subscriptionEndDate) || isWithin15Days(subscriptionEndDate);
  const [showPopup, setShowPopup] = useState(shouldShowPopup);
  const popupMessage = isSubscriptionValid(subscriptionEndDate)
    ? `Your subscription is about to end on ${subscriptionEndDate && !isNaN(new Date(subscriptionEndDate)) ? new Date(subscriptionEndDate).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" }) : "N/A"}!`
    : "Your subscription has ended!";

  return (
    <div style={{ maxWidth: "800px", margin: "50px auto", textAlign: "center" }}>
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; }
            to { opacity: 1; }
          }
          @keyframes slideIn {
            from { transform: translateY(-20px); opacity: 0; }
            to { transform: translateY(0); opacity: 1; }
          }
        `}
      </style>
      <div
        style={{
          background: "linear-gradient(145deg, #e0f2fe, #bfdbfe)",
          borderRadius: "20px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.2), 0 4px 10px rgba(0, 0, 0, 0.15)",
          padding: "28px",
          transition: "transform 0.4s ease, box-shadow 0.4s ease",
          ":hover": { transform: "scale(1.04)", boxShadow: "0 14px 40px rgba(0, 0, 0, 0.25), 0 0 0 2px #60a5fa" },
          backdropFilter: "blur(12px)",
          border: "1px solid rgba(255, 255, 255, 0.3)",
        }}
      >
        <h1
          style={{
            fontSize: "1.875rem",
            fontWeight: "800",
            color: "#1e3a8a",
            marginBottom: "1.75rem",
            letterSpacing: "0.03em",
            fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
          }}
        >
          Subscription Details
        </h1>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          }}
        >
          <label
            style={{
              fontSize: "0.95rem",
              fontWeight: "600",
              color: "#475569",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            Email:
          </label>
          <input
            type="email"
            value={email}
            onChange={handleEmailChange}
            placeholder="Enter your email"
            style={{
              fontSize: "1.25rem",
              color: "#0f172a",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
              padding: "8px",
              borderRadius: "8px",
              border: emailError ? "2px solid #b91c1c" : "1px solid #d1d5db",
              width: "70%",
            }}
          />
        </div>
        {emailError && (
          <p
            style={{
              fontSize: "0.9rem",
              color: "#b91c1c",
              marginBottom: "1rem",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            {emailError}
          </p>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          }}
        >
          <label
            style={{
              fontSize: "0.95rem",
              fontWeight: "600",
              color: "#475569",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            Product Name:
          </label>
          <h2
            style={{
              fontSize: "1.375rem",
              fontWeight: "700",
              color: "#0f172a",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            {product?.name || "Unknown Product"}
          </h2>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          }}
        >
          <label
            style={{
              fontSize: "0.95rem",
              fontWeight: "600",
              color: "#475569",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            Price:
          </label>
          <p
            style={{
              fontSize: "1.375rem",
              fontWeight: "700",
              color: "#059669",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            ₹{product?.price?.toLocaleString("en-IN") || "0"}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          }}
        >
          <label
            style={{
              fontSize: "0.95rem",
              fontWeight: "600",
              color: "#475569",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            Start Date:
          </label>
          <p
            style={{
              fontSize: "1.25rem",
              color: "#0f172a",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            {subscriptionStartDate && !isNaN(new Date(subscriptionStartDate))
              ? new Date(subscriptionStartDate).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : "Not Available"}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          }}
        >
          <label
            style={{
              fontSize: "0.95rem",
              fontWeight: "600",
              color: "#475569",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            End Date:
          </label>
          <p
            style={{
              fontSize: "1.25rem",
              color: "#0f172a",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            {subscriptionEndDate && !isNaN(new Date(subscriptionEndDate))
              ? new Date(subscriptionEndDate).toLocaleDateString("en-US", {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })
              : "Not Available"}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "1.5rem",
          }}
        >
          <label
            style={{
              fontSize: "0.95rem",
              fontWeight: "600",
              color: "#475569",
              textTransform: "uppercase",
              letterSpacing: "0.06em",
              fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            }}
          >
            Status:
          </label>
          <span
            style={{
              padding: "8px 18px",
              borderRadius: "9999px",
              fontSize: "0.95rem",
              fontWeight: "600",
              backgroundColor: isSubscriptionValid(subscriptionEndDate) ? "#ccfbf1" : "#fee2e2",
              color: isSubscriptionValid(subscriptionEndDate) ? "#0d9488" : "#b91c1c",
              boxShadow: "0 3px 6px rgba(0, 0, 0, 0.1)",
              transition: "background-color 0.3s ease",
            }}
          >
            {isSubscriptionValid(subscriptionEndDate) ? "Active" : "Expired"}
          </span>
        </div>
        <p
          style={{
            fontSize: "0.95rem",
            fontStyle: "italic",
            color: "#1e40af",
            backgroundColor: "#eff6ff",
            padding: "10px 14px",
            borderRadius: "10px",
            marginBottom: "1.75rem",
            fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          }}
        >
          You can renew your subscription 15 days before the end date
        </p>
        {(() => {
          return (
            <>
              {showPopup && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    backdropFilter: "blur(5px)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    zIndex: 1000,
                    animation: "fadeIn 0.3s ease",
                  }}
                >
                  <div
                    style={{
                      background: "linear-gradient(145deg, #f8fafc, #e2e8f0)",
                      borderRadius: "16px",
                      padding: "24px",
                      maxWidth: "400px",
                      width: "90%",
                      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.3)",
                      textAlign: "center",
                      animation: "slideIn 0.3s ease",
                    }}
                  >
                    <h2
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: "700",
                        color: "#1e3a8a",
                        marginBottom: "1rem",
                        fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
                      }}
                    >
                      {popupMessage}
                    </h2>
                    <p
                      style={{
                        fontSize: "0.95rem",
                        color: "#475569",
                        marginBottom: "1.5rem",
                        fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
                      }}
                    >
                      Renew now to continue enjoying {product?.name || "your subscription"}.
                    </p>
                    <div style={{ display: "flex", gap: "1rem", justifyContent: "center" }}>
                      <button
                        onClick={handlePayment}
                        disabled={loading || !!emailError}
                        style={{
                          padding: "10px 20px",
                          background: loading || !!emailError ? "#d1d5db" : "linear-gradient(90deg, #1d4ed8, #3b82f6)",
                          color: "white",
                          borderRadius: "8px",
                          fontSize: "0.95rem",
                          fontWeight: "600",
                          border: "none",
                          cursor: loading || !!emailError ? "not-allowed" : "pointer",
                          transition: "background 0.3s ease, transform 0.2s ease",
                          ":hover": !loading && !emailError ? { background: "linear-gradient(90deg, #3b82f6, #60a5fa)", transform: "translateY(-2px)" } : {},
                        }}
                      >
                        {loading ? "Processing..." : "Renew Now"}
                      </button>
                      <button
                        onClick={() => setShowPopup(false)}
                        style={{
                          padding: "10px 20px",
                          background: "#e5e7eb",
                          color: "#1f2937",
                          borderRadius: "8px",
                          fontSize: "0.95rem",
                          fontWeight: "600",
                          border: "none",
                          cursor: "pointer",
                          transition: "background 0.3s ease, transform 0.2s ease",
                          ":hover": { background: "#d1d5db", transform: "translateY(-2px)" },
                        }}
                      >
                        Dismiss
                      </button>
                    </div>
                  </div>
                </div>
              )}
              <button
                onClick={handlePayment}
                disabled={loading || !!emailError}
                style={{
                  padding: "14px 28px",
                  background: loading || !!emailError ? "#d1d5db" : "linear-gradient(90deg, #1d4ed8, #3b82f6)",
                  color: "white",
                  borderRadius: "12px",
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  border: "none",
                  cursor: loading || !!emailError ? "not-allowed" : "pointer",
                  marginTop: "1.75rem",
                  width: "100%",
                  transition: "background 0.3s ease, transform 0.2s ease, box-shadow 0.3s ease",
                  ":hover": !loading && !emailError ? { background: "linear-gradient(90deg, #3b82f6, #60a5fa)", transform: "translateY(-2px)", boxShadow: "0 0 15px rgba(59, 130, 246, 0.5)" } : {},
                }}
              >
                {loading ? "Processing..." : "Buy Now"}
              </button>
              {statusMsg && (
                <p
                  style={{
                    marginTop: 20,
                    color: "#f97316",
                    fontSize: "1.1rem",
                    fontWeight: "500",
                    fontFamily: "'Inter', 'Helvetica Neue', sans-serif",
                  }}
                >
                  {statusMsg}
                </p>
              )}
            </>
          );
        })()}
      </div>
    </div>
  );
};

export default RazorpayCheckout;